import { render, staticRenderFns } from "./turrezdetay.vue?vue&type=template&id=b9c6ba08&"
import script from "./turrezdetay.vue?vue&type=script&lang=js&"
export * from "./turrezdetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports